/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { BillingPricingOption } from './BillingPricingOption';
// @ts-ignore
import {
// @ts-ignore
    BillingPricingOptionFromJSON,
// @ts-ignore
    BillingPricingOptionFromJSONTyped,
// @ts-ignore
    BillingPricingOptionToJSON,
} from './BillingPricingOption';

/**
 * 
 * @export
 * @interface BillingPricingPlan
 */
export interface BillingPricingPlan {
    /**
     * 
     * @type {string}
     * @memberof BillingPricingPlan
     */
    planCode: BillingPricingPlanPlanCodeEnum;
    /**
     * 
     * @type {Array<BillingPricingOption>}
     * @memberof BillingPricingPlan
     */
    options: Array<BillingPricingOption>;
}


/**
 * @export
 */
export const BillingPricingPlanPlanCodeEnum = {
    Paid: 'paid'
} as const;
export type BillingPricingPlanPlanCodeEnum = typeof BillingPricingPlanPlanCodeEnum[keyof typeof BillingPricingPlanPlanCodeEnum];


/**
 * Check if a given object implements the BillingPricingPlan interface.
 */
// @ts-ignore
export function instanceOfBillingPricingPlan(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "planCode" in value;
    isInstance = isInstance && "options" in value;

    return isInstance;
}

// @ts-ignore
export function BillingPricingPlanFromJSON(json: any): BillingPricingPlan {
    return BillingPricingPlanFromJSONTyped(json, false);
}

// @ts-ignore
export function BillingPricingPlanFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingPricingPlan {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'planCode': json['plan_code'],
        'options': ((json['options'] as Array<any>).map(BillingPricingOptionFromJSON)),
    };
}

// @ts-ignore
export function BillingPricingPlanToJSON(value?: BillingPricingPlan | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'plan_code': value.planCode,
        'options': ((value.options as Array<any>).map(BillingPricingOptionToJSON)),
    };
}

